// Actions
import { createAction } from "redux-actions";
import types from "./types";

export default {
  getTransactionRecord: createAction(types.GET_TRANSACTION_RECORD),
  getTransactionRecordSuccess: createAction(types.GET_TRANSACTION_RECORD_SUCCESS),
  getTransactionRecordFail: createAction(types.GET_TRANSACTION_RECORD_FAILED),
};
